/**
 * Application runtime constants.
 */
export class AppConsts {
    public static remoteServiceBaseUrl: string;
    public static OSSRequestUrl: string;
    public static portalBaseUrl: string;
    public static appBaseUrl: string;

    public static uploadApiUrl = '/api/File/Upload';

    public static maxProfilPictureMb = 1;
    public static maxCompanyPictureMb = 5;
    public static maxProFileMb = 5;

    public static localeMappings: any;
    public static ngZorroLocaleMappings: any;
    public static ngAlainLocaleMappings: any;
    public static momentLocaleMappings: any;

    public static readonly userManagement = {
        defaultAdminUserName: 'admin',
    };

    public static readonly localization = {
        defaultLocalizationSourceName: 'QYB',
    };

    public static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token',
    };

    public static readonly grid = {
        defaultPageSize: 10,
        defaultPageSizes: [5, 10, 15, 20, 25, 30, 50, 80, 100],
    };

    public static readonly notificationCount = 5;
    public static LR_Url: any;
    public static EntryUrl: any;
    public static DefaultTenant: any;
    public static DefaultMsgLinkModuleId: any;

    public static readonly AppLogsUrl =
        'https://e.gitee.com/ssoft/projects/273270/docs/853401/file/2179044/preview';
    public static readonly FontIcon = '//at.alicdn.com/t/font_2811377_3s2f4ert9sl.js';
    public static readonly TenantInfoExpiresTime = 30;
}
